// extracted by mini-css-extract-plugin
export default {"footer":"Losung_footer__91Ebh","small":"Losung_small__e2hs0","headline":"Losung_headline__rd+zn","losung":"Losung_losung__4E9mj"};